import { createMetricsFactory } from 'metrics-js';

export const Metrics = createMetricsFactory('data-fetching-client');
